import React from 'react';

interface LatchButtonProps {
  isAdmin: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const LatchButton: React.FC<LatchButtonProps> = ({ isAdmin, onClick, disabled }) => {
  return (
    <div className="group flex relative pl-2">
      <label
        className={`relative inline-flex items-center ${
          disabled || isAdmin ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
        }`}>
        <input
          type="checkbox"
          checked={isAdmin}
          onChange={onClick}
          disabled={disabled || isAdmin}
          className="sr-only peer"
        />
        <div className='w-11 h-6 bg-gray peer-focus:outline-none peer-focus:ring-4 rounded-full dark:bg-gray peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[""] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-black' />
      </label>
      <div className="absolute -top-9 left-1/2 -translate-x-1/2 z-10 scale-95 opacity-0 group-hover:opacity-100 group-hover:scale-100 transition-all bg-white dark:bg-gray-800 text-sm text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-600 rounded-lg shadow px-2 py-1 whitespace-nowrap">
        {isAdmin ? 'Already an Admin' : 'Switch to Admin'}
      </div>
    </div>
  );
};

export default LatchButton;
